export default {
  "login-register": "登錄/註冊",
  "language": "語言",
  "currency": "貨幣",
  "home-page": "主頁",
  "front-page": "頭版",
  "attraction": "景點門票",
  "hotel": "酒店",
  "transport": "租車接送",
  "ferry": "渡輪",
  "packages": "旅游配套",
  "customer-service-phone": "客服電話：+65 98809383 或 +65 6438 2811",
  "manage-booking": "管理預訂",
  "products": "產品",
  "point-to-point": "私人接送",
  "disposal": "用車",
  "seat-in-coach": "專車接送",
  "express": "跨境巴士",
  "transport-packages": "接送配套",
  "pages": "頁面",
  "about-us": "關於我們",
  "contact-us": "聯繫我們",
  "faq": "常見問題",
  "privacy-policy": "隱私政策",
  "sign-in": "登錄",
  "to-your-account": "到你的賬戶",
  "forget-your-password": "忘記密碼？",
  "login": "登錄",
  "or": "或",
  "and": "和",
  "no-account-yet": "還沒有賬戶？",
  "sign-up-now": "現在就註冊！",
  "loading": "加載中...",
  "forget-password": "忘記密碼",
  "send": "發送",
  "sign-up": "註冊",
  "info-password-validation": "您的密碼必須至少有 6 個字符，並且必須包含至少 1 個小寫字母、1 個大寫字母、1 個特殊字符（例如：{'@'}$%&*#' ) 和 1 個數字。",
  "by-registering-i-agree-with": "通過註冊，我同意",
  "terms-conditions": "條款和條件",
  "of-ace-toures-travel-pte-ltd": "創意旅游私人有限公司",
  "register": "註冊",
  "already-have-account": "已經有賬戶了？",
  "sign-in-now": "現在登錄！",
  "register-success": "註冊成功",
  "reset-password": "重置密碼",
  "reset-code-success": "重置代碼成功",
  "reset-code-description": "密碼重置成功，請使用新密碼登錄",
  "go-to-login": "去登錄",
  "you-just-one-click-away": "你只需點擊一下",
  "to-confirm-email-address": "要確認您的電子郵件地址，請點擊按鈕",
  "you-account-has-been-activated": "您的帳戶已被激活",
  "profile": "個人資料",
  "edit-profile": "編輯個人資料",
  "manage-passengers": "管理乘客",
  "e-wallet": "電子錢包",
  "credit": "信用",
  "name": "名稱",
  "username": "用戶名",
  "email": "電郵地址",
  "nationality": "國籍",
  "street-address": "街道地址",
  "phone-code": "電話代碼",
  "phone-number": "電話號碼",
  "edit": "編輯",
  "balance": "余额",
  "code": "代碼",
  "date": "日期",
  "type": "類型",
  "order-id": "訂單編號",
  "select_currency": "選擇貨幣",
  "period": "期間",
  "select_period": "選擇期間",
  "clear": "清除",
  "opening_balance": "期初餘額",
  "current_balance": "目前餘額",
  "end_balance": "期末餘額",
  "month_january": "一月",
  "month_february": "二月",
  "month_march": "三月",
  "month_april": "四月",
  "month_may": "五月",
  "month_june": "六月",
  "month_july": "七月",
  "month_august": "八月",
  "month_september": "九月",
  "month_october": "十月",
  "month_november": "十一月",
  "month_december": "十二月",
  "amount": "金額",
  "base": "基礎貨幣",
  "status": "狀態",
  "Top-up": "充值",
  "Trans-Dedu": "交易歷史",
  "topup-balance": "充值電子錢包",
  "topup-history": "充值餘額",
  "agent-name": "代理名稱",
  "bank": "銀行從",
  "note": "注",
  "file": "文件",
  "save": "保存",
  "back": "後退",
  "tour-package": "旅游配套",
  "tour-transfer": "旅游接送",
  "one-way": "單程",
  "round-trip": "往返",
  "next-select-bus": "下一步，選擇巴士",
  "next-select-vehicle": "下一步，選擇車輛",
  "modify-search": "修改搜索",
  "depart-trip": "出發旅行",
  "return-trip": "回程",
  "filter": "篩選",
  "depart-time": "出發時間",
  "bus-operator": "巴士運營商",
  "amenities": "設施",
  "reset": "重置",
  "reset-filter": "重新篩選",
  "morning": "早上（凌晨00:00 - 上午 11:59）",
  "afternoon": "下午 (12:00 PM - 6:59 PM)",
  "evening": "晚上 (7:00 PM - 11:59 PM)",
  "route": "路線",
  "seat": "座位",
  "fare": "票價",
  "select-seat": "選擇座位",
  "no-result-found": "沒有找到結果",
  "please-try-another-search": "請嘗試其他搜索",
  "pick-up-point": "出發點",
  "drop-off-point": "下車點",
  "payung-sekaki": "Payung Sekaki",
  "air-dingin": "Air Dingin",
  "vehicle-type": "車輛類型",
  "bus": "巴士",
  "car": "汽車",
  "business-partner": "商業夥伴",
  "3m-transport": "3M Transport (Sari Indah)",
  "harapan-jaya": "Harapan Jaya",
  "pahala-kencana": "Pahala Kencana",
  "more-than": "多餘",
  "no-of-pax": "人數",
  "image": "圖像",
  "luggage-capacity": "行李容量",
  "select": "選擇",
  "port-to-city": "港口到城市",
  "city-to-city": "城市到城市",
  "city-to-port": "城市到港口",
  "singapore-to-malaysia": "新加坡到馬來西亞",
  "singapore-and-malaysia": "新加坡和馬來西亞",
  "porttocity": "港口到城市",
  "citytocity": "城市到城市",
  "citytoport": "城市到港口",
  "singaporetomalaysia": "新加坡到馬來西亞",
  "sgptomy": "新加坡到馬來西亞",
  "search": "搜索",
  "seating-capacity": "座位容量",
  "terms-and-conditions": "條款和條件",
  "1-ticketing": "1. 票務",
  "ticketing-desc": "我們作為各家航空公司的代理。因此，根據各自航空公司的條款和條件出售機票。1A. 如果已售出的機票取消/修改/退款，服務費為除了各航空公司收取的費用外，還需支付 50.00 美元*。還需要注意的是，某些機票沒有退款價值，或者不能根據航空公司作為銷售條件的一部分設定的條件取消/修改。1B . 如果出現未出現的情況，將從門票的退款價值中扣除 $200.00* 的費用（如果此類門票具有退款價值），以彌補座位的浪費。",
  "2-hotels": "2. 酒店",
  "hotels-desc": "我們代表新加坡海外的多家酒店銷售酒店客房。因此適用他們所施加的條款和條件。2A。如果預訂房間未出現，則收取一晚房費。2B。如果取消/修改已預訂的客房，將收取 $50.00* 的費用。請注意，某些酒店可能不接受任何取消/修改客房預訂（尤其是在高峰期），在這種情況下，乘客將被無權獲得任何退款。",
  "3-visas": "3. 簽證",
  "visas-desc": "我們提供各種簽證申請服務。根據其複雜程度，會收取服務費。這是大使館/領事館自行收取的任何費用之外的費用。",
  "4-travel-insurance": "4. 旅遊保險",
  "travel-insurance-desc": "我們銷售特別打包的旅行保險。所售保險受保險集團各自保單中規定的條款和條件的約束。強烈建議所有客戶購買旅行保險以涵蓋旅行取消等領域, 個人行李, 人身事故, 傷害和疾病. 在任何情況下, 本公司均不得被解釋為根據合同安全運輸客戶或其行李和物品的承運人. 我們的工作人員將很樂意協助查詢任何旅行保險。",
  "5-tour-packages": "5. 旅遊套餐",
  "5a-reservations-deposit-payment": "5A. 預訂、押金和付款",
  "reservations-deposit-payment-desc": "預訂時需支付總機票費用的 50% 押金。餘款需在出發前 14 天支付。本公司不承認任何押金構成旅遊、旅行的確認安排或門票。",
  "5b-cancellations-amendments": "5B. 取消/修改",
  "5b-desc-1": "必須以書面形式取消客戶確認的預訂，以免造成誤解。將收取以下費用：對於本公司運營的旅行團，",
  "5b-desc-2": "對於由第三方提供的旅行或組件，例如游輪、酒店、航空公司、汽車租賃、火車等，應根據各自第三方的條款和條件收取取消費用，處理每人每項服務收費 50 新元。",
  "5b-desc-3": "公司旅遊團會員取消旅遊，請注意本公司是作為服務商的代理。定金或全額付款後，一切安排仍以最終確認為準。如無法確認安排，本公司將盡量在出發前至少2週（團體遊及7天及以上游）或1週（6天及以下游）通知客戶，並退還如行程取消，將支付旅遊費用，本公司不承擔任何進一步責任。本公司保留在出發前以任何理由取消任何行程的權利，包括但不限於人數不足參加者。如果公司決定，可以推薦其他旅遊安排。",
  "period-of-cancellation-notice": "取消通知期間",
  "cancellation-charges-per-person": "每人取消費用",
  "from-departure-date": "(從出發日期)",
  "hotel-tour-packages": "酒店/旅遊套餐",
  "chartered-flights": "包機和機票/遊輪/鐵路通票/汽車和組合和長途汽車租賃",
  "30-days-and-more": "30 天以上",
  "deposit-non-refundable": "押金不退還",
  "15-to-29-days": "15 到 29 天",
  "75-of-tour-fare": "旅遊票價的 75%",
  "100-tour-fare": "100% 旅遊票價",
  "14-days-and-below": "14 天及以下",
  "100-of-tour-fare": "100% 的旅遊費用",
  "5c-amendments": "5C. 修正案",
  "amendments-desc": "一般修改 客戶在確認預訂後進行的任何修改（不包括出發日期、旅行類型或機票），公司將收取每人每次修改 S$50* 的管理費。 對於出發日期或旅行類型的修改，將收取上述取消費用。 公司對行程的修改 公司將努力不對旅遊套餐做出任何重大改變。 但是，本公司保留在任何時候因不可預見的情況進行細微更改的權利，且不予賠償，尤其是在旺季期間。",
  "5d-refund": "5D. 退款",
  "refund-desc": "旅遊套票退款（不含機票部分） 客戶以現金和支票付款，2-4週內以支票形式退還給客戶。高峰期退款可能需要大約 6 週。對於客戶使用信用卡付款，退款將通過信用卡公司進行，大約需要 4-6 週，高峰期大約需要 2 個月。",
  "6-accomodation": "6. 住宿",
  "accomodation-desc": "如果預訂或要求的住宿不可用，我們將盡一切努力尋找另一個類似標準的住宿。",
  "7-seat-rotation": "7. 座椅旋轉",
  "seat-rotation-desc": "為方便所有團員，請客人在旅遊期間輪換車廂座位安排，請在領隊要求時配合/指導。",
  "8-travel-request": "8. 旅行請求",
  "travel-request-desc": "如果對特殊餐食、飲食要求、相鄰房間等有任何要求，請在預訂時告知本公司。此類要求以確認和供應情況為準。",
  "9-travel-documents": "9. 旅行證件",
  "travel-documents-desc": "客戶自行負責確保其國際護照自返回新加坡之日起至少有 6 個月的有效期，以及相關簽證、ESTA、疫苗接種和旅行證件公司將盡可能協助乘客獲得必要的簽證，但不保證使館/領事館的批准。",
  "10-responsibilities": "10. 責任",
  "responsibilities-desc": "本公司及其聯營公司僅作為運輸公司、酒店及酒店的代理人。旅遊項目的其他負責人。他們對因旅行證件不當、持有非法物品或違規行為而導致的傷害、損壞、事故、丟失、延誤、盜竊、檢疫、海關監管、罷工、行程變更、驅逐出境或移民當局拒絕入境不承擔任何責任。造成人身或財產。任何損失和費用由客戶負責。所有適當的旅行證件均由客戶自行負責。本公司保留更改行程、旅行安排、酒店預訂等的權利。如有必要或在不可抗力的情況下，本公司保留在出發日期之前以任何理由取消任何旅行的權利，包括人數不足參與者。如果發生這種情況，公司將退還全部款項，而公司不承擔進一步的義務。本公司將推薦替代旅遊，最好是同一目的地或其他目的地。如果客戶決定不接受替代方案，公司將全額退還所有已支付的款項，而無需承擔進一步的義務。如果認為任何個人的行為損害或不符合其他乘客和整個旅行團的利益、和諧和福利，本公司也保留要求任何個人退出旅行團的權利。此後，本公司不再對任何此類人承擔任何責任。本公司的任何領隊/導遊或其他僱員或代理人均無權對本公司承擔任何責任，且本公司不受任何聲明或陳述的約束，除非以書面形式並由本公司管理層簽署。本公司保留在未獲得客戶任何進一步同意的情況下，在與本公司一起遊覽期間拍攝客戶照片和影片以用於宣傳冊廣告或宣傳材料的權利。對於客戶在旅行期間購買的任何商品，無論商品是否存在質量缺陷、不適合客戶的目的、與提供給客戶的樣品不符或被客戶拒收，本公司均不對客戶承擔任何責任。客戶出於任何原因，即使貨物是在構成旅遊套餐（包括行程）的一部分的商店購買的，或者是旅遊服務、他們的導遊、僕人、僱員或獨立承包商特別推薦的商店，也不是公司或旅遊服務對客戶購買上述商品的貨款承擔責任。",
  "about-us-desc": "ACE Tours Travel Pte Ltd 是新加坡領先的旅行社之一，成立於 2003 年。我們的董事總經理 Edward Tay 先生在旅遊行業擁有 30 多年的經驗，專注於產品開發、團隊服務和高端直銷。近年來，我們在產品開發方面積累了豐富的專業知識，每年平均接待超過100,000名各國遊客。經過多年的努力和進步，我們與大中華區、印度支那、印度尼西亞、菲律賓、印度等地的 100 多家領先的商務和旅行社建立了密切的長期合作關係。通過適應和發展以適應社區的需求，並服務於每個人的不同需求和預算。我們的旅遊包括豪華旅遊、MICE 旅遊、旅遊規劃、會議、MICE 獎勵、遺產旅遊、學生團體、休閒高爾夫旅遊等。我們擁有自己的導遊和教練團隊，並與酒店經營者、旅遊景點和餐廳建立密切的關係。那一年。我們的運營團隊負責處理所有酒店、航班、景點、遊輪的預訂和預訂。近年來，我司實現網絡化、規模化、品牌化發展戰略，讓現代出行更加便捷、全面、高效。 ACE Tours 以提供專業和優質的服務為宗旨，以多年的經驗為國內外客戶和行業創造更多驚喜和促銷。我們將繼續為新加坡繁華的旅遊業做出更多貢獻，同時成就一個服務與品牌雙贏的品牌。我們將是您永遠的商業夥伴。",
  "contact-us-desc": "我們期待收到您的來信，請注意，我們至少需要 2x24 小時才能與您聯繫。 謝謝你。",
  "Reach Out": "聯繫我們",
  "We are looking forward for your contact, please kindly note that it would take at least 2x24 hours for us to reach you. Thank you.": "我們期待收到您的來信，請注意，我們至少需要 2x24 小時才能與您聯繫。 謝謝你。",
  "Opening Hours": "營業時間",
  "Monday - Friday 09:00 AM - 10:00 PM SGT": "週一至週五上午 9:00 至晚上 10:00（新加坡標準時間）",
  "Saturday 12:00 PM - 06:00 PM SGT": "星期六 12:00 PM - 18:00 PM（新加坡標準時間）",
  "Sunday 12:00 PM - 06:00 PM SGT": "週日 12:00 PM - 18:00 PM（新加坡標準時間）",
  "contact-name": "聯繫人姓名",
  "contact-email": "聯繫郵箱",
  "contact-phone": "聯繫電話",
  "submit": "提交",
  "privacy-policy-desc-1": "您的隱私對我們很重要。",
  "privacy-policy-desc-2": "您的信息將僅用於此請求的目的，不會用於任何其他目的。",
  "hello": "你好,",
  "hello-please": "你好，請",
  "signup-cap": "注冊",
  "login-cap": "登錄",
  "where to or what trip": "去哪里或去什麼旅行",
  "country": "國家",
  "city": "城市",
  "product": "產品",
  "outbound": "外出",
  "package": "配套",
  "booking-history": "預訂歷史",
  "logout": "登出",
  "tour-packages": "旅游配套",
  "download": "下載",
  "check-this-offer": "查看此報價",
  "recomend-ptp-desc": "有了我們的服務，旅行變得更輕鬆、更實用。這裡有一些點對點的建議，可以幫助您計劃旅行。",
  "recomend-disposal-desc": "通過我們的垃圾處理服務，出行將變得輕鬆，您將在需要時擁有所需的車輛。以下是一些推薦的位置。",
  "recomend-sic-desc": "享受更舒適、靈活的出行方式。我們的服務讓您輕鬆遊覽城市，開始新的一天。這裡推荐一些 SIC 的熱門路線。",
  "recomend-express-desc": "使用方便，價格實惠，輕鬆穿梭於世界各個城市之間。這裡有一些受歡迎的快遞路線。",
  "keyword-tour-packages": "關鍵詞（搜索活動或景點）",
  "minimum-sic": "SIC 的最低購買數量為 2 位。",
  "boarding-point": "出發地點",
  "deparature-date": "出發日期",
  "return-date": "返回日期",
  "pickup-date": "接客日期",
  "pickup-time": "接客時間",
  "pickup-point": "接客地點",
  "hours": "小時",
  "point option": "私人轉移選項",
  "deparature-time": "出發時間",
  "return-time": "返回時間",
  "destination": "目的地",
  "order-history": "訂單歷史",
  "filter-by": "過濾",
  "all-products": "所有產品",
  "cruise": "渡輪",
  "all": "全部",
  "verifying": "驗證中",
  "completed": "已完成",
  "expired": "已到期",
  "cancelled": "已取消",
  "trips-found": "搜到...行程",
  "start-from": "從...開始",
  "instant": "立刻確認",
  "currently-there-are-no-result-for-this-timing": "目前沒有這個時間的搜索結果",
  "proceed-one-way": "繼續單程",
  "proceed-one-way-only": "繼續單程",
  "continue-transaction": "繼續訂單",
  "continue": "繼續",
  "go-to-departtrip": "前往去程",
  "go-to-returning-trips": "前往回程",
  "up-to": "至",
  "packages-found": "找到...配套",
  "sorting-here": "在這裡排序",
  "highest-price": "最高價",
  "lowest-price": "最低價",
  "available": "可用",
  "occupied": "佔據",
  "front-side": "前面",
  "choose-seats-for": "座位",
  "choose-seats-for-desc": "如果適用，請在下一步指定兒童票（2-12 歲）的數量。 2歲不用買票。",
  "total": "全部的",
  "welcome-manage-booking": "歡迎管理我的預訂",
  "view-your-booking": "查看您的預訂",
  "access-all-booking-details": "查看所有預訂詳情",
  "booking-reference": "预订参考",
  "view-booking": "查看預訂",
  "ace-tours-privacy-policy": "Ace Tours隱私政策",
  "ace-tours-privacy-policy-desc": "此數據保護通知（“通知”）列出了Ace Tours＆Travel Pte Ltd（以下稱為“我們”，“我們”或“我們的”）可能會收集，使用，使用，披露或以其他方式處理的個人數據我們的客戶符合《個人數據保護法》（“ PDPA”）。本通知適用於我們擁有或在我們控制的個人數據，包括我們參與的組織擁有的個人數據，這些數據是為了我們的目的收集，使用，使用，披露或處理個人數據。",
  "personal-data": "個人資料",
  "personal-data-desc-1": "如本通知中所用：“客戶”是指（a）通過任何方式與我們聯繫的個人，以了解更多有關我們提供的商品或服務的信息，或者（b）可以或已與我們簽訂合同我們提供任何商品或服務； “個人數據”是指關於可以識別的客戶的數據，無論是否正確：（a）從該數據中； （b）從我們擁有或可能可以訪問的其他信息中。",
  "personal-data-desc-2": "根據您與我們互動的性質，我們可能會從您那裡收集的一些個人數據示例包括您的姓名和身份信息，例如您的nric號碼，聯繫信息，例如您的地址，電子郵件地址或電話號碼，國籍，性別，性別，出生日期，婚姻狀況，照片和其他視聽信息，就業信息和財務信息，例如信用卡號，借記卡號碼或銀行帳戶信息。",
  "personal-data-desc-3": "本通知中使用的其他術語應具有PDPA中給出的含義（上下文允許）。",
  "collection-use-and-disclosure-of-personal-data": "收集，使用和披露個人數據",
  "collection-desc-1": "通常，我們可能會在我們的網站上收集，使用，披露，轉移和存儲您輸入的任何信息，或通過各種方式（包括電話，電子郵件，查詢或預訂）在我們的銷售辦公室，SMS，傳真，郵政和任何平台上提供公司不時使用（集體“平台”）。我們收集的信息包括可以識別您（“個人數據”）的信息，包括但不限於您的姓名，聯繫電話，郵政和電子郵件地址，聯繫人偏好，以及您與我們預訂，信用卡信息。我們可能還會要求您為您提供有關您參與的旅行偏好，忠誠度，頻繁的傳單和/或汽車租賃計劃的信息個人數據集體稱為“個人信息”）。您無需提供請求的個人信息，我們可能會阻止為您提供某些產品或服務。",
  "collection-desc-2": "通常，我們通常不會收集您的個人數據）您（或您的授權代表）已通知收集數據的目的，（ii）您（或您的授權代表）已為這些目的或您的個人數據收集和使用提供書面同意，或（b）PDPA或其他法律允許或要求未經同意或要求收集和使用個人數據。在收集任何其他個人數據之前，我們將尋求您的同意，然後在出於未通知您的目的之前使用您的個人數據（除非法律允許或授權）。",
  "collection-desc-3": "我們可能出於以下任何目的收集和使用您的個人數據：<br> a）在或與您提供的商品和/或服務有關的過程中或與您所要求的商品和/或服務有關； <br> b）驗證您的身份； <br> c）響應您的處理，處理和處理查詢，請求，申請，投訴和反饋； <br> d）與我們進行管理； <br> e）處理或信貸交易; <br> f）發送有關我們的商品或服務的營銷信息，包括通知您我們的營銷活動，計劃和促銷，幸運抽獎，會員資格和獎勵計劃以及其他促銷活動； <br> g）遵守任何適用的法律，法規，實踐守則，準則或規則，或協助任何政府和/或監管機構進行的執法和調查； h）您提供的信息的任何其他目的； <br> i）向包括我們的第三方服務提供者和代理商在內的任何無關的第三方傳輸，以及相關的政府和/或監管機構，無論是在新加坡還是國外，供您使用上述目的； <br> j）與上述有關或與上述有關的任何其他附帶業務目的。<br> k）調查和競賽，我們可能會通過我們不時進行的調查或競賽來要求與您有關的個人信息。通過調查收集的個人信息將用於監視或改善我們服務的使用和滿意度。通過比賽收集的個人信息將用於通知獲獎者和獎勵獎品。<br> l）可以記錄或監控您的電話，以進行質量控制和員工培訓。我們將在合理必要的情況下保留呼叫記錄，然後刪除。在電話期間從您獲得的任何個人信息將根據本隱私政策的規定進行處理。",
  "collection-desc-4": "我們希望使您輕鬆利用與旅行有關的機會。我們這樣做的一種方法是，通過電子郵件，短信，傳真或帖子向您發送營銷消息，其中包含有關您的旅行有關的興趣和與旅行有關的特殊優惠的信息。請注意，您可以撤回您的同意，以向您發送營銷信息。請參閱本隱私政策的選擇加入和選擇退出政策部分，該部分列出了您如何設置與此類營銷信息有關的偏好。",
  "collection-desc-5": "我們可能會披露您的個人數據：<br>（a）在我們在提供您要求的商品或服務方面或與您有關的義務履行義務的情況下需要進行此類披露；或<br>（b）向第三方服務提供商，代理商和其他組織，我們從事上面第6條中列出的任何功能。請注意，這些第三方供應商可以根據需要與您聯繫，以獲取有關您的其他信息，以促進您通過我們進行的旅行預訂； <br>（c）管理您的帳戶，包括處理賬單和提供旅行通知; <br>（d）一般與您溝通； <br>（e）回答您的問題和評論； <br>（f），允許我們在必要時與您聯繫以獲取客戶服務； <br >（g）衡量並改善我們的產品，服務和網站的興趣； <br>（h）在我們的網站上自定義您的經驗； <br>（i）作為您的任何獎勵和認可計劃的一部分獎勵您選擇加入; <br>（j）解決問題，收取費用或解決問題； <br>（k）以防止潛在的禁止或非法活動； <br>（l）在您制定時執行我們的條款和條件與我們一起預訂旅行； （m）在收集點上另外通知您。",
  "collection-desc-6": "我們可以與之共同提供產品或服務的業務合作夥伴。如果您選擇接收有關這些產品或服務的信息，我們可能會與這些第三方合作夥伴共享有關您的信息，包括您的個人信息，以便他們可以直接通過電子郵件或發布有關其產品和服務的信息與您聯繫。",
  "collection-desc-7": "我們希望使您輕鬆利用與旅行有關的機會。我們這樣做的一種方法是，通過電子郵件，短信，傳真或帖子向您發送營銷消息，其中包含有關您的旅行有關的興趣和與旅行有關的特殊優惠的信息。請注意，您可以撤回您的同意，以向您發送營銷信息。請參閱本隱私政策的選擇加入和選擇退出政策部分，該部分列出了您如何設置與此類營銷信息有關的偏好。",
  "collection-desc-8": "即使在您與我們的關係（例如，根據合同）的關係（例如，在任何方式）之後（包括在適用的情況下，在適用的情況下），即使您與我們的關係（例如，根據合同）已被終止或更改的情況（例如，在適用時，使我們能夠根據與您的任何合同執行我們的權利）。",
  "withdrawing-your-consent": "撤回您的同意",
  "withdrawing-desc-1": "您為您提供的個人數據收集，使用和披露的同意將保持有效，直到您以書面形式撤回。您可以撤回同意書，並要求我們停止使用和/或通過以下內容提交您的請求或通過電子郵件向我們的數據保護官提交您的請求，從而在下面提供的聯繫方式上披露您的個人數據。",
  "withdrawing-desc-2": "收到您撤回同意書的書面請求後，我們可能需要合理的時間（取決於請求的複雜性及其對您與您的關係的影響），以便您的請求進行處理，並向我們通知您的後果加入相同的情況，包括可能影響您對我們的權利和責任的任何法律後果。通常，我們將尋求在收到的十（10）個工作日內處理您的請求。",
  "withdrawing-desc-3": "儘管我們尊重您撤回同意的決定，但請注意，根據您的請求的性質和範圍，我們可能無法繼續向您提供商品或服務，在這種情況下，我們將在此之前通知您完成您的請求處理。如果您決定取消您的同意撤回，請以書面形式通知我們以上第8條所述的方式。",
  "withdrawing-desc-4": "請注意，撤回同意並不影響我們繼續收集，使用和披露個人數據的權利，在未經適用法律允許或要求的情況下進行收集，使用和披露的個人數據。",
  "access-to-and-correction-of-personal-data": "訪問和糾正個人數據",
  "access-desc-1": "如果您希望（a）訪問我們對您持有的個人數據副本的訪問請求，或有關我們使用或披露您的個人數據的方式的信息，或（b）校正請求以正確或更新我們持有的有關您的任何個人數據，您可以通過以下聯繫詳細信息以書面形式或通過電子郵件向我們的數據保護官提交請求。",
  "access-desc-2": "請注意，訪問請求可能會收取合理的費用。如果是這樣，我們將在處理您的請求之前通知您費用。",
  "access-desc-3": "我們將盡快回答您的請求。如果我們在收到您的請求後的三十（30）天內無法回應您的請求，我們將在我們能夠響應您的請求的時間的三十（30）天內以書面形式通知您。如果我們無法為您提供任何個人數據或進行您要求的更正，我們通常會告知您我們無法這樣做的原因（除非我們不需要在PDPA下進行此操作）。",
  "protection-of-personal-data": "保護個人數據",
  "protection-desc-1": "為了保護您的個人數據免受未經授權的訪問，收集，使用，披露，複製，修改，處置或類似風險，我們引入了適當的管理，物理和技術措施，例如最新的防病毒保護，加密和使用隱私過濾我們的所有存儲和傳輸個人數據，並在內部和我們的授權第三方服務提供商和代理商中披露個人數據，僅在需要的基礎上。",
  "protection-desc-2": "但是，您應該知道，沒有通過Internet或電子存儲方法傳輸的方法是完全安全的。儘管無法保證安全性，但我們努力保護您的信息的安全性，並不斷審查和增強我們的信息安全措施。",
  "accuracy-of-personal-data": "個人數據的準確性",
  "accuracy-desc": "我們通常依靠您（或您的授權代表）提供的個人數據。為了確保您的個人數據是最新，完整和準確的，如果您的個人數據發生了更改，請通過以下信息詳細信息通知我們的數據保護官或通過電子郵件通知我們的數據保護官。",
  "retention-of-personal-data": "保留個人數據",
  "retention-desc-1": "只要有必要實現收集的目的，或者根據適用法律的要求或允許，我們就可以保留您的個人數據。",
  "retention-desc-2": "我們將停止保留您的個人數據，或刪除與您相關聯的方法，一旦合理地假設該保留不再滿足收集個人數據的目的，並且沒有用於法律或商業目的所需的時間更長。",
  "transfers-of-personal-data": "新加坡以外的個人數據傳輸",
  "transfers-desc": "我們通常不會將您的個人數據轉移到新加坡以外的國家。但是，如果這樣做，我們將獲得您的同意，以確保您的個人數據繼續獲得至少與PDPA提供的保護標準。",
  "data-protection-officer": "數據保護官",
  "data-protection-officer-desc": "如果您對我們的個人數據保護政策和程序有任何查詢或反饋，或者如果您想以以下方式提出任何請求，則可以聯繫我們的數據保護官員：<a href ='mailto：info@acetours.sg' > info@acetours.sg </a>",
  "effect-of-notice-and-changes-to-notice": "通知和更改的效果要注意",
  "effect-desc-1": "本通知適用於與我們有關收集，使用和披露您的個人數據的任何其他通知，合同條款和同意條款。",
  "effect-desc-2": "我們可以不時修改此通知，而無需任何事先通知。您可以通過參考該通知最後更新的日期來確定是否進行了任何此類修訂。您繼續使用我們的服務構成了您對此類變化的認可和接受。",
  "privacy-policy-effective-date": "生效日期：[2020年9月1日]",
  "privacy-policy-last-updated": "最後更新：[2020年9月1日]",
  "price": "價格",
  "addon": "添加", 
  "information-details": "詳細信息",
  "payment": "支付",
  "departing-info": "出發詳情",
  "departing-date": "出發日期",
  "depart-from": "出發地點",
  "duration": "車程時間",
  "arrive-at": "抵達",
  "vehicle-info": "車輛信息",
  "ticket-total-price": "總票價",
  "return-info": "回程詳情",
  "return-from": "從...回來",
  "order-summary": "訂單摘要",
  "read-more": "閱讀更多",
  "payment-info": "支付信息",
  "depart-journey-fare": "去程票價",
  "return-journey-fare": "回程票價",
  "surcharge": "附加費用",
  "admin": "行政",
  "discount": "折扣",
  "promo-code": "折扣碼",
  "apply-code": "使用代碼",
  "adult": "成人",
  "child": "兒童",
  "infant": "嬰兒",
  "senior": "樂齡",
  "pcs": "件",
  "remarks": "備註",
  "enter-your-code": "輸入您的代碼",
  "Bank Transfer/PayNow": "銀行轉賬/PayNow",
  "E-Wallet": "電子錢包",
  "Visa Card /Master Card": "簽證卡 /主卡",
  "refresh": "刷新",
  "proceed-to-payment": "前往支付",
  "payment-is-verifying": "正在驗證支付",
  "payment-successful": "支付成功",
  "contact-details": "聯繫方式",
  "payment-method": "付款方式",
  "person-name": "名字",
  "date-booking": "訂購日期",
  "bank-transfer-success-desc": "您的訂單正在驗證，我們將在收到您的付款後發送確認，並在驗證付款後繼續確認您的訂單。",
  "wallet-success-desc": "成功！您的訂單詳細信息將在接下來的5-10分鐘內發送到您的電子郵件收件箱",
  "back-to-manage-booking": "返回訂單管理",
  "back-to-order-history": "返回訂單歷史",
  "detail-address-pickup": "載客與送達地址詳情",
  "pickup-address": "載客地址",
  "search-your-pickup-address": "搜索您的載客地址",
  "drop-off-address": "送達地址",
  "search-your-drop-off-address": "搜索您的送達地址",
  "detail-schedule": "詳細時間表和地址",
  "label-detail-schedule": "請輸入您的詳細地址和詳細行程安排",
  "search-your-detail-schedule": "例：在樟宜机场Termimal 3 Entrance 3上车，前往Song Fa Bak Kut Teh Clarke Quay，然后在Clarke Quay - The Central shopping mall入口下车（靠近巴士站），最后下车到Marina Bay Sands Hotel。",
  "contact-person-responsible": "聯繫人（負責訂購的人）",
  "personal-details": "個人資料",
  "title": "稱謂",
  "Mr": "先生",
  "Mrs": "女士",
  "Ms": "小姐",
  "Dr": "博士",
  "first-name": "名字",
  "last-name": "姓氏",
  "enter-your-first-name": "輸入您的名字",
  "enter-your-last-name": "輸入您的姓氏",
  "contact-number": "聯繫電話",
  "enter-your-phone-number": "輸入你的手機號碼",
  "email-address": "電郵地址",
  "enter-your-email-address": "舒服您的電郵地址",
  "code-reference": "代碼參考",
  "enter-your-code-reference": "在此輸入...",
  "passenger": "乘客",
  "dob": "出生日期",
  "enter-your-dob": "輸入你的出生日期",
  "pob": "出生地",
  "enter-your-pob": "輸入您的出生地",
  "no-passport": "護照號碼",
  "enter-your-no-passport": "輸入您的護照號碼",
  "doe": "效期截止日期",
  "enter-your-doe": "輸入效期截止日期",
  "poi": "發照地點",
  "enter-your-poi": "輸入發照地點",
  "bank-transfer": "銀行轉帳",
  "payment-confirmation": "確認支付",
  "upload": "上載",
  "payment-proof": "付款憑證",
  "i-have-paid": "已支付",
  "pickup-detail": "載客地址詳情",
  "search-your-pickup-detail": "輸入您的詳細下車地址",
  "drop-off-detail": "送達地址詳情",
  "search-your-drop-off-detail": "查找您的送貨地址",
  "how-to-top-up": "如何充值",
  "top-up-confirmation": "確認充值",
  "pay-now": "馬上支付",
  "required-validation": "{msg}是必填項目",
  "required-validation-row": "{msg} 是第 {row} 行的必填字段",
  "password": "密碼",
  "Personal Details - Title": "個人詳細信息 - 稱謂",
  "Personal Details - First Name": "個人詳細信息 - 名字",
  "Personal Details - Last Name": "個人詳細信息 - 姓氏",
  "Contact Details - Contact Code": "聯繫方式 - 聯繫代碼",
  "Contact Details - Contact Code must be choosen": "聯繫方式 - 必須選擇聯繫代碼",
  "Contact Details - Contact Number": "聯繫方式 - 聯繫電話",
  "Contact Details - Contact Number cannot be less than 8 digit": "聯繫方式 - 聯繫電話不能少於8位數字",
  "Contact Details - Email": "聯繫方式 - 電子郵件",
  "Please enter a valid email address": "請填寫有效的電子郵件地址",
  "Detail Schedule": "詳細流程",
  "Pickup Address": "載客地址",
  "Dropoff Address": "送達地址",
  "Pickup detail": "載客地址詳情",
  "Dropoff detail": "送達地址詳情",
  "Passenger - Title": "乘客-稱謂",
  "Passenger - First Name": "乘客 - 名字",
  "Passenger - Last Name": "乘客 - 姓氏",
  "Passenger - Nationality": "乘客 - 國籍",
  "Passenger - Date of birth": "乘客 - 出生日期",
  "Passenger - Place of birth": "乘客 - 出生地",
  "Passenger - No. Passport": "乘客-護照號碼",
  "Passenger - Date of expiry": "乘客-效期截止日期",
  "Passenger - Place of issue": "乘客-發照地點",
  "port": "港口",
  "create-password": "創建密碼",
  "enter-password": "輸入您的密碼",
  "confirm-password": "創建密碼",
  "enter-confirm-password": "輸入您的確認密碼",
  "create-account": "創建帳戶",
  "by-creating-account-you-agree": "創建賬戶即表示您同意我們的",
  "login-info-1": "預訂中的所有客人都必須創建自己的帳戶。",
  "login-info-2": "註冊您的詳細信息並個性化您的旅行，讓您完全安心。",
  "price-for": "價格”",
  "hour": "小時",
  "car-rental-in": "租車在",
  "showing-available-cars-for": "顯示可用汽車",
  "pickup-point-at": "上車點",
  "fullname": "全名",
  "referral-from": "您如何认识我们",
  "cancellation": "取消",
  "cancellation_reason": "取消原因",
  "information_cancelation_fee": "取消費用資訊",
  "please_provide_cancellation_reason": "請提供取消原因",
  "no_notification": "你沒有任何通知",
  "notification_history_log": "通知（歷史記錄)",
  'read_all': '全部閱讀',
  'customer_service_phone': '客服電話',
  'full-name-note': '護照/官方身份證上的姓名。',
  'email-confirmation-note': '您的預訂確認和電子票將發送至此電子郵件地址。',
}